module.exports = __webpack_public_path__ + "img/top_ten_drug_icon.0d4da6e7.svg";